import AddToCartModal from "./add-to-cart-modal";
import showToast from "./show-toast";

interface AddToCartParams {
    product_id: string | number;
    quantity: string | number;
    variation_id?: string | number;
    variation?: Record<string, string>;
}

interface AddToCartResponse {
    error?: boolean;
    fragments?: Record<string, string>;
    cart_hash?: string;
}

interface FormData {
    action: string;
    product_id: string | number;
    quantity: number;
    variation_id?: number;
    variation?: Record<string, string>;
    [key: string]: any;
}

declare global {
    interface Window {
        wc_add_to_cart_params: {
            wc_ajax_url: string;
        }
    }
}

const MODAL_DELAY_MS = 150;
const ERROR_MESSAGE = "Produkt nie jest dostępny";

export default function handleAjaxAddToCart() {


    jQuery(function ($) {
        function extractParamsFromHref(url: string): AddToCartParams {
            const params = new URLSearchParams(url);
            const productId = params.get('/?add-to-cart') ?? 0;
            const quantity = params.get('quantity') ?? '1';
            const variationId = params.get('variation_id') ?? undefined;

            const variation: Record<string, string> = {};
            params.forEach((value, key) => {
                if (key.startsWith('attribute_')) {
                    variation[key] = value;
                }
            });

            return {
                product_id: productId,
                quantity: quantity,
                variation_id: variationId,
                variation: Object.keys(variation).length > 0 ? variation : undefined
            };
        }

        function isSingleProductPage(): boolean {
            return document.body.classList.contains('single-product')
        }

				function scrollToVariations() {
					if(isSingleProductPage() && isVariableProduct()) {
						const variations = document.querySelector('.single-product-variations')
						if(variations) {
							variations.scrollIntoView({
								block: 'center',
								inline: "center",
								behavior: 'smooth'
							})
						}
					}
				}

				function shakeElement(element: HTMLElement, duration = 600) {
					element.classList.add('shake');
					setTimeout(() => {
						element.classList.remove('shake');
					}, duration);
				}

        function isVariableProduct(): boolean {
            return $('.single-product.product-type-variable').length > 0;
        }

        function getDataInSingleProductPage(): AddToCartParams | null {
            const singleProductAddToCartForm = document.querySelector('.single-product-details-wrapper form.cart');
            if (!singleProductAddToCartForm) return null;

            const hiddenInputProductId = singleProductAddToCartForm.querySelector('input[name="product_id"]') as HTMLInputElement;
            const hiddenInputVariationId = singleProductAddToCartForm.querySelector('input[name="variation_id"]') as HTMLInputElement;
            const hiddenInputQuantity = singleProductAddToCartForm.querySelector('input[name="quantity"]') as HTMLInputElement;

            if (!hiddenInputProductId?.value) return null;

            const variation: Record<string, string> = {};
            const variationInputs = singleProductAddToCartForm.querySelectorAll('select[name^="attribute_"], input[name^="attribute_"]');
            variationInputs.forEach((input) => {
                const inputElement = input as HTMLInputElement | HTMLSelectElement;
                if (inputElement.value) {
                    variation[inputElement.name] = inputElement.value;
                }
            });

            return {
                product_id: hiddenInputProductId.value,
                quantity: hiddenInputQuantity?.value ?? '1',
                variation_id: hiddenInputVariationId?.value,
                variation: Object.keys(variation).length > 0 ? variation : undefined
            };
        }

        function handleAjaxError(error: unknown, errorMessage: string = ERROR_MESSAGE): void {
            console.error('Add to cart error:', error);
            showToast({
                title: errorMessage,
                type: 'error',
            });
        }

        function handleAjaxSuccess(response: AddToCartResponse, errorMessage: string = ERROR_MESSAGE): void {
            if (response.error) {
                showToast({
                    title: errorMessage,
                    type: 'error',
                });
                return;
            }

            $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash]);
            $(document.body).trigger('wc_fragment_refresh');
            $(document.body).trigger('show_add_to_cart_modal');

            const addToCartModal = new AddToCartModal('#add-to-cart-modal');
            setTimeout(() => addToCartModal.showModal(), MODAL_DELAY_MS);
        }

        $('[data-ajax-add-to-cart]').on('click', function (e) {
            e.preventDefault();
            const $item = $(this);
            const url = $item.attr('href') ?? '';
            let data = extractParamsFromHref(url);


            if (!data.product_id) {
                handleAjaxError('Nieprawidłowy ID produktu');
                return;
            }



            $.ajax({
                url: `${window.location.origin}${window.wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart')}`,
                type: 'POST',
                data,
                dataType: 'json',
                beforeSend: function() {
                    $item.addClass('adding-to-cart');
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    handleAjaxError(errorThrown);
                },
                success: function(response: AddToCartResponse) {
                    handleAjaxSuccess(response);
                },
                complete: function() {
                    $item.removeClass('adding-to-cart');
                }
            });
        });

        $('.single-product form.cart').on('submit', function (e) {
            e.preventDefault();

            const $form = $(this);
            const $button = $form.find('button[type="submit"]');

            if ($button.hasClass('adding-to-cart')) {
                return;
            }

            const productIdInput = $form.find('input[name="add-to-cart"]').val() || $form.find('input[name="product_id"]').val();
            const productId = productIdInput ? String(productIdInput) : null;

            if (!productId) {
                handleAjaxError('Nieprawidłowy ID produktu');
                return;
            }

            const isVariableProduct = $form.hasClass('variations_form');
            const variation: Record<string, string> = {};
            let variationId: number | undefined;

            if (isVariableProduct) {
                const $variationId = $form.find('input[name="variation_id"]');
                variationId = $variationId.length ? Number($variationId.val()) : undefined;

                $form.find('.variations select').each(function() {
                    const attrName = $(this).attr('name');
                    const attrValue = $(this).val();
                    if (attrName && attrValue) {
                        variation[attrName] = String(attrValue);
                    }
                });

                if (!variationId || variationId === 0) {
										showToast({
											title: 'Wybierz wariant produktu',
											type: 'info'
										})
										scrollToVariations();
										shakeElement($form.find('.variations')[0] as HTMLElement);
                    return;
                }
            }

            const quantityInput = $form.find('input[name="quantity"]');
            const quantity = quantityInput.length ? parseInt(String(quantityInput.val()), 10) : 1;

            if (isNaN(quantity) || quantity < 1) {
                handleAjaxError('Nieprawidłowa ilość produktu');
                return;
            }

            const data: FormData = {
                action: 'custom_woocommerce_add_to_cart',
                product_id: productId,
                quantity: quantity,
            };

            if (isVariableProduct && variationId) {
                data.variation_id = variationId;
                data.variation = variation;
            }

            $form.find('input[type=radio], select, textarea, input[name="add-to-cart"], .bundled_product_checkbox, .bundled_qty').each(function() {
                const $field = $(this);
                const name = $field.attr('name');
                const value = $field.val();

                if (name && value) {
                    data[name] = String(value);
                }
                if($field.hasClass('bundled_product_checkbox') && $field.is(':checked')) {
                    data[name] = String(value);
                }
            });

            $.ajax({
                url: `${window.location.origin}${window.wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'custom_woocommerce_add_to_cart')}`,
                type: 'POST',
                data,
                beforeSend: function() {
                    $button.addClass('adding-to-cart').prop('disabled', true);
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    handleAjaxError(errorThrown);
                },
                success: function(response: AddToCartResponse) {
                    handleAjaxSuccess(response);
                },
                complete: function() {
                    $button.removeClass('adding-to-cart').prop('disabled', false);
                }
            });
        });
    });
}